import Template from "app/models/template"
import { Params } from "app/redux/templates/templates.reducer"

export enum Types {
  GET = "TEMPLATES_GET",
  GET_SUCCESS = "TEMPLATES_GET_SUCCESS",
  GET_FAIL = "TEMPLATES_GET_FAIL",
  DELETE = "TEMPLATES_DELETE",
  DELETE_SUCCESS = "TEMPLATES_DELETE_SUCCESS",
  DELETE_FAIL = "TEMPLATES_DELETE_FAIL",
  POST = "TEMPLATES_POST",
  POST_SUCCESS = "TEMPLATES_POST_SUCCESS",
  POST_FAIL = "TEMPLATES_POST_FAIL",
  GET_BY_ID = "TEMPLATES_GET_BY_ID",
  GET_BY_ID_SUCCESS = "TEMPLATES_GET_BY_ID_SUCCESS",
  GET_BY_ID_FAIL = "TEMPLATES_GET_BY_ID_FAIL",
  PUT = "TEMPLATES_PUT",
  PUT_SUCCESS = "TEMPLATES_PUT_SUCCESS",
  PUT_FAIL = "TEMPLATES_PUT_FAIL",
  DUPLICATE = "TEMPLATES_DUPLICATE",
  DUPLICATE_SUCCESS = "TEMPLATES_DUPLICATE_SUCCESS",
  DUPLICATE_FAIL = "TEMPLATES_DUPLICATE_FAIL",
}

export type Action =
  | GetTemplatesAction
  | GetTemplatesSuccessAction
  | GetTemplatesFailAction
  | DeleteTemplatesByIdAction
  | DeleteTemplatesByIdSuccessAction
  | DeleteTemplatesByIdFailAction
  | PostTemplatesAction
  | PostTemplatesSuccessAction
  | PostTemplatesFailAction
  | GetTemplatesByIdAction
  | GetTemplatesByIdSuccessAction
  | GetTemplatesByIdFailAction
  | PutTemplatesAction
  | PutTemplatesSuccessAction
  | PutTemplatesFailAction
  | DuplicateTemplatesAction
  | DuplicateTemplatesSuccessAction
  | DuplicateTemplatesFailAction

export type GetTemplatesAction = {
  payload: { params?: Params }
  type: Types.GET
}

export type GetTemplatesSuccessAction = {
  payload: { data: Template[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetTemplatesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostTemplatesAction = {
  payload: { data: Template }
  type: Types.POST
}

export type PostTemplatesSuccessAction = {
  type: Types.POST_SUCCESS
  payload: { data: Template }
}

export type PostTemplatesFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type DeleteTemplatesByIdAction = {
  payload: { id: number }
  type: Types.DELETE
}

export type DeleteTemplatesByIdSuccessAction = {
  type: Types.DELETE_SUCCESS
}

export type DeleteTemplatesByIdFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export type GetTemplatesByIdAction = {
  type: Types.GET_BY_ID
  payload: { id: number }
}

export type GetTemplatesByIdSuccessAction = {
  type: Types.GET_BY_ID_SUCCESS
  payload: { data: Template | undefined }
}

export type GetTemplatesByIdFailAction = {
  type: Types.GET_BY_ID_FAIL
  payload: { errors: object }
}

export type PutTemplatesAction = {
  type: Types.PUT
  payload: { data: Template }
}

export type PutTemplatesSuccessAction = {
  type: Types.PUT_SUCCESS
  payload: { data: Template }
}

export type PutTemplatesFailAction = {
  type: Types.PUT_FAIL
  payload: { errors: object }
}

export type DuplicateTemplatesAction = {
  payload: { id: number; name: string; redirect?: boolean }
  type: Types.DUPLICATE
}

export type DuplicateTemplatesSuccessAction = {
  payload: { data: Template }
  type: Types.DUPLICATE_SUCCESS
}

export type DuplicateTemplatesFailAction = {
  payload: { errors: object }
  type: Types.DUPLICATE_FAIL
}

export function getTemplates(params?: Params): GetTemplatesAction {
  return {
    type: Types.GET,
    payload: { params },
  }
}

export function getTemplatesSuccess(data: Template[] | undefined): GetTemplatesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getTemplatesFail(errors: object): GetTemplatesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function deleteTemplatesById(id: number): DeleteTemplatesByIdAction {
  return {
    payload: { id },
    type: Types.DELETE,
  }
}

export function deleteTemplatesByIdSuccess(): DeleteTemplatesByIdSuccessAction {
  return {
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteTemplatesByIdFail(errors: object): DeleteTemplatesByIdFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}

export function postTemplates(data: Template): PostTemplatesAction {
  return {
    payload: { data },
    type: Types.POST,
  }
}

export function postTemplatesSuccess(data: Template): PostTemplatesSuccessAction {
  return {
    payload: { data },
    type: Types.POST_SUCCESS,
  }
}

export function postTemplatesFail(errors: object): PostTemplatesFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
export function getTemplatesById(id: number): GetTemplatesByIdAction {
  return {
    payload: { id },
    type: Types.GET_BY_ID,
  }
}
export function getTemplatesByIdSuccess(data: Template | undefined): GetTemplatesByIdSuccessAction {
  return {
    payload: { data },
    type: Types.GET_BY_ID_SUCCESS,
  }
}
export function getTemplatesByIdFail(errors: object): GetTemplatesByIdFailAction {
  return {
    payload: { errors },
    type: Types.GET_BY_ID_FAIL,
  }
}
export function putTemplates(data: Template): PutTemplatesAction {
  return {
    payload: { data },
    type: Types.PUT,
  }
}
export function putTemplatesSuccess(data: Template): PutTemplatesSuccessAction {
  return {
    payload: { data },
    type: Types.PUT_SUCCESS,
  }
}
export function putTemplatesFail(errors: object): PutTemplatesFailAction {
  return {
    payload: { errors },
    type: Types.PUT_FAIL,
  }
}

export function duplicateTemplates(id: number, name: string, redirect?: boolean): DuplicateTemplatesAction {
  return {
    payload: { id, name, redirect },
    type: Types.DUPLICATE,
  }
}

export function duplicateTemplatesSuccess(data: Template): DuplicateTemplatesSuccessAction {
  return {
    payload: { data },
    type: Types.DUPLICATE_SUCCESS,
  }
}

export function duplicateTemplatesFail(errors: object): DuplicateTemplatesFailAction {
  return {
    payload: { errors },
    type: Types.DUPLICATE_FAIL,
  }
}
